import { memo } from 'react'
import { HStack, IconButton, Button } from '@chakra-ui/react'
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'

interface PaginationCarouselProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  isLoading?: boolean
}

export const PaginationCarousel = memo(function PaginationCarousel({
  currentPage,
  totalPages,
  onPageChange,
  isLoading,
}: PaginationCarouselProps) {
  if (!totalPages || totalPages <= 1) {
    return null
  }

  const windowSize = 5
  let start = Math.max(1, currentPage - Math.floor(windowSize / 2))
  let end = start + windowSize - 1

  if (end > totalPages) {
    end = totalPages
    start = Math.max(1, end - windowSize + 1)
  }

  const pages: number[] = []
  for (let page = start; page <= end; page += 1) {
    pages.push(page)
  }

  const handleChange = (page: number) => {
    if (!isLoading) {
      onPageChange(page)
    }
  }

  return (
    <HStack spacing={1}>
      <IconButton
        aria-label="Previous page"
        icon={<LuChevronLeft />}
        size="sm"
        variant="ghost"
        isDisabled={isLoading || currentPage === 1}
        onClick={() => handleChange(currentPage - 1)}
      />
      {pages.map((page) => (
        <Button
          key={page}
          size="sm"
          variant={page === currentPage ? 'solid' : 'ghost'}
          colorScheme={page === currentPage ? 'purple' : 'gray'}
          onClick={() => handleChange(page)}
          isDisabled={isLoading}
        >
          {page}
        </Button>
      ))}
      <IconButton
        aria-label="Next page"
        icon={<LuChevronRight />}
        size="sm"
        variant="ghost"
        isDisabled={isLoading || currentPage === totalPages}
        onClick={() => handleChange(currentPage + 1)}
      />
    </HStack>
  )
})
